import { Component } from '@angular/core';

// Animations config
import { expand } from '../../animations';

@Component({
  selector: 'app-collapsable',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        display: block;
        overflow: hidden;
      }
    `,
  ],
  animations: [expand],
})
export class CollapsableComponent {}
